import { FormProps, Form as RACForm } from "react-aria-components";
import { twMerge } from "tailwind-merge";

/**
 * Form
 *
 * Accessibility-first form wrapper with consistent spacing.
 * Defaults to ARIA validation to use custom error styling instead of native browser tooltips.
 */
export function Form(props: FormProps) {
  return <RACForm validationBehavior="aria" {...props} className={twMerge("flex flex-col gap-6", props.className)} />;
}
